module.exports = __webpack_public_path__ + "static/media/2_01.b7184e8c.webp";